import { Card } from '@ipfabric/ui-components/Card/Card';
import type { ReactNode } from 'react';
import { SearchableSection } from '../DiscoverySearch/SearchableSection';

type Props = {
  renderSnippet: (name: 'cliSessions' | 'allowTelnet') => ReactNode;
};

export const CliSessions = (props: Props) => (
  <Card>
    <SearchableSection
      id='advanced-cli-sessions-settings-card'
      highlightOn={['advancedCli']}
      className='p flex flex-col'
    >
      <div className='text-default text-level-5 font-semibold font-heading'>
        Session settings
      </div>
      <SearchableSection id='advanced-cli-sessions'>
        <div className='my-xs'>{props.renderSnippet('cliSessions')}</div>
      </SearchableSection>
      <SearchableSection id='advanced-allow-telnet'>
        <div className='my-xs'>{props.renderSnippet('allowTelnet')}</div>
      </SearchableSection>
    </SearchableSection>
  </Card>
);
